'use client';
import React from 'react';
import { Button, Tooltip } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

interface DeleteShapeButtonProps {
  onDelete: () => void;
  locked?: boolean;
  className?: string;
}

const DeleteShapeButton = React.forwardRef<HTMLButtonElement, DeleteShapeButtonProps>(
  ({ onDelete, locked, className }, ref) => {
    return (
      <Tooltip title={'Delete'}>
        <Button
          ref={ref}
          danger
          icon={<DeleteOutlined />}
          className={`mini-toolbar-button ${className || ''}`}
          disabled={locked}
          onClick={onDelete} // Only attach onClick if not last shape
        />
      </Tooltip>
    );
  },
);

DeleteShapeButton.displayName = 'DeleteShapeButton';

export default DeleteShapeButton;
